/* eslint-disable */
import moment from 'moment';
import 'moment/locale/ru';

import tourCriteriaService from "@/js/common/Domain/Service/tourCriteria";
import NightRangeFactory from "@/js/common/Domain/Factory/NightRange";

let NightRangeView = Backbone.View.extend({
	label: 'Количество ночей',
	setAdditionalLabel: function (nights) {
		var $label = this.$el.find('.numOfNights'),
			labelText = 'на ';

		if (nights.from == nights.to) {
			labelText += nights.to + ' ноч' + nights.from.wordEnding('ь;и;ей');
		} else {
			labelText += nights.from + '-' + nights.to + ' ноч' + nights.to.wordEnding('ь;и;ей');
		}

		this.$numOfNights.text(labelText);
	},
	$numOfNights: function () {
		this.$numOfNights = this.$el.find('.numOfNights');
	},
	$datesLabel: function () {
		this.$datesLabel = $('.formDropdownContent .bottom .datesLabel', this.$el);
	},
	$nightsLabel: function () {
		this.$nightsLabel = $('.formDropdownContent .bottom .nightsLabel', this.$el);
	},
	scrollToElement: function (e) {
		var currenPosition = $(document).scrollTop(),
			windowHeight = $(window).height(),
			headerHeight = $('.headerContainer').height(),
			menuHeight = $('.menuContainer').height(),
			elementPosition = this.$el.offset().top,
			self = this,
			scrollTo;

		scrollTo = elementPosition;

		headerHeight ? scrollTo -= headerHeight : '';
		menuHeight ? scrollTo -= menuHeight : '';

		scrollTo -= 50;

		setTimeout(function () {
			self.showDropdown(self.$el);
		}, 1);

		if (elementPosition > currenPosition + windowHeight || elementPosition < currenPosition) {
			$("html,body").animate({scrollTop: scrollTo}, 200);
			return true;
		}

		return false;
	},
	$fromField: function () {
		this.$fromField = $('.tour-duration-from', this.$el);
	},
	$formInputPlace: function () {
		this.$formInputPlace = $('.formInputPlace', this.$el);
	},
	$toField: function () {
		this.$toField = $('.tour-duration-to', this.$el);
	},
	controlChanged: function (event) {
		var valueFrom = parseInt(this.$fromField.spinner("value"), 10),
			valueTo = parseInt(this.$toField.spinner("value"), 10),
			nightRange;

		tourCriteriaService.addTourCriteriaChangedField('nightRange');

		if (valueFrom > valueTo) {
			if ($(event.target).hasClass('tour-duration-from')) {
				valueTo = valueFrom;
				this.$toField.spinner("value", valueTo);
			} else {
				valueFrom = valueTo;
				this.$fromField.spinner("value", valueFrom);
			}
		}

		nightRange = {
			from: valueFrom,
			to: valueTo
		};

		if (this.setAdditionalLabel) {
			this.setAdditionalLabel(nightRange);
		}

		this.model.set('model', new NightRangeFactory(nightRange), {initiator: 'view'});
	},
	updateButtons: function () {
		this.updateButton.call(this.$fromField);
		this.updateButton.call(this.$toField);
	},
	updateButton: function (event, params) {
		var value = params && params.value ? params.value : $(this).val(),
			min = $(this).spinner('option', 'min'),
			max = $(this).spinner('option', 'max'),
			$decreaseButton = $(this).parent().find('.ui-spinner-down'),
			$increaseButton = $(this).parent().find('.ui-spinner-up');

		if (value <= min) {
			$decreaseButton.addClass('ui-state-disabled');
		} else {
			$decreaseButton.removeClass('ui-state-disabled');
		}

		if (value >= max) {
			$increaseButton.addClass('ui-state-disabled');
		} else {
			$increaseButton.removeClass('ui-state-disabled');
		}
	},
	toggleDropdown: function () {
		if (!this.$el.hasClass('disable')) {
			this.$el.toggleClass("open");
			if(this.$el.hasClass('open')){
				this.dataLayerAnalyticsEvent();
			}
		}
	},
	showDropdown: function ($element) {
		var self = this;
		this.$el.addClass("open");
	},
	initSpinner: function () {
		this.$fromField.spinner({
			min: 1,
			max: 29,
			icons: {down: "ui-icon-minus", up: "ui-icon-plus"}
		}).on('spinstop', $.proxy(this.controlChanged, this))
			.on('change', this.updateButton);

		this.$toField.spinner({
			min: 1,
			max: 29,
			icons: {down: "ui-icon-minus", up: "ui-icon-plus"}
		}).on('spinstop', $.proxy(this.controlChanged, this))
			.on('change', this.updateButton);

	},
	dataLayerAnalyticsEvent(){
		if(this.dataLayerAnalytics){
			this.dataLayerAnalytics.searchFieldsEvent('nightsOpen')
		}
	},
	modelChanged: function (event, model, context) {
		var from, to;

		if (model === null) {
			this.$el.addClass('disable');
		} else {
			this.$el.removeClass('disable');
			this.$fromField.spinner("value", model.get('from'));
			this.$toField.spinner("value", model.get('to'));

			if (this.setAdditionalLabel) {
				this.setAdditionalLabel({
					from: model.get('from'),
					to: model.get('to')
				});
			}
			this.updateButtons();
			this.updateBottomLabel();
		}
	},
	updateBottomLabel: function () {
		var datesLabel,
			nightsLabel,
			checkInDateRange = this.checkInDateRange.get('model'),
			dateFrom = checkInDateRange ? checkInDateRange.get('from') : false,
			dateTo = checkInDateRange ? checkInDateRange.get('to') : false,
			departureCityData = this.departureCityData.get('model'),
			daysRange = departureCityData ? departureCityData.get('daysRange') : 3,
			nightRange = this.model.get('model'),
			nightRangeFrom = nightRange ? nightRange.get('from') : null,
			nightRangeTo = nightRange ? nightRange.get('to') : null,
			middleDate;

		if (dateFrom && dateTo && dateFrom.getTime() !== dateTo.getTime()) {
			if ((moment(dateTo).diff(moment(dateFrom), 'days') > daysRange * 2) || this.preventDaysPlusmin) {
				datesLabel = '<b>' + moment(dateFrom).format('DD.MM') + ' по ' + moment(dateTo).format('DD.MM') + '</b>';
			} else {
				middleDate = new Date(dateTo.getTime() - daysRange * 24 * 3600 * 1000);
				datesLabel = '<b>' + moment(middleDate).format('DD.MM') + '</b> (± ' + daysRange + ' ' + daysRange.wordEnding('день;дня;дней') + ')';
			}
		} else if (dateFrom && dateTo) {
			datesLabel = '<b>' + moment(dateFrom).format('DD.MM') + '</b>';
		}

		if (nightRangeFrom && nightRangeTo && nightRangeFrom != nightRangeTo) {
			nightsLabel = nightRangeFrom + " - " + nightRangeTo + ' ноч' + nightRangeTo.wordEnding('ь;и;ей');
		} else if (nightRangeFrom) {
			nightsLabel = nightRangeFrom + ' ноч' + nightRangeFrom.wordEnding('ь;и;ей');
		}

		this.$datesLabel.html(datesLabel);
		this.$nightsLabel.text(nightsLabel);
	},

	initDomEvents: function () {
		var self = this;
		$('> .formInput', this.$el).on('click', $.proxy(this.toggleDropdown, this));

		$(document).click(function (event) {
			var $dropdowns = self.$el.filter('.open'),
				$hideDropdowns,
				clickedContainer = $(event.target).parents('.formDropdown'),
				clickedDropdown = $(event.target);

			$hideDropdowns = $dropdowns.not(clickedContainer).not(clickedDropdown);
			$hideDropdowns.removeClass('open');
		});

		this.$el.addClass('disable');
	},
	initModelEvents: function () {
		var self = this;
		this.model.on('change:model', $.proxy(this.modelChanged, this));
		this.checkInDateRange.on('change:model', function () {
			self.updateBottomLabel.call(self);
		});
	},
	initialize: function (options) {
		var self = this,
			model = this.model.get('model');

		this.checkInDateRange = options.checkInDateRange;
		this.departureCityData = options.departureCityData;
		this.preventDaysPlusmin = !_.isUndefined(options.daysPlusMin) && options.daysPlusMin === false ? true : false;
		this.dataLayerAnalytics = options.dataLayerAnalytics;
		this.$fromField();
		this.$toField();
		this.$formInputPlace();
		this.$datesLabel();
		this.$nightsLabel();
		this.$numOfNights();
		this.initDomEvents();
		this.initModelEvents();
		this.initSpinner();
	}
});

export default NightRangeView;